import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PLAN_CODE_MAX, PLAN_NAME_MAX } from '../../../../../Consts/plans.const';
import {
  CreatePlanDialogData,
  CreatePlanDialogResult,
} from '../../../Interfaces/plan-dialog.interface';

@Component({
  selector: 'app-create-plan-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule],
  templateUrl: './create-plan-dialog.component.html',
  styleUrl: './create-plan-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatePlanDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<CreatePlanDialogComponent, CreatePlanDialogResult>>(MatDialogRef);

  readonly data = inject<CreatePlanDialogData>(MAT_DIALOG_DATA);

  readonly codeMax = PLAN_CODE_MAX;
  readonly nameMax = PLAN_NAME_MAX;

  readonly formGroup: FormGroup = this._formBuilder.group({
    market_id: ['', [Validators.required]],
    code: ['', [Validators.required, Validators.maxLength(PLAN_CODE_MAX)]],
    name: ['', [Validators.required, Validators.maxLength(PLAN_NAME_MAX)]],
    version: [1, [Validators.required, Validators.min(1)]],
    is_active: [true],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({
      marketId: String(this.formGroup.value.market_id),
      code: String(this.formGroup.value.code).trim(),
      name: String(this.formGroup.value.name).trim(),
      version: Number(this.formGroup.value.version),
      isActive: Boolean(this.formGroup.value.is_active),
    });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
